import React, { Fragment } from 'react';
import CountUp from 'react-countup';
import { Col, Card, CardHeader, Media, CardBody, Row } from 'reactstrap';

import { H5, H6 } from '../../../AbstractElements';

import { SalesData } from '../../../Data/Widgets/general';
import { SaleDetails } from '../../../Constant';

const Sales = () => {
  return (
    <Fragment>
      <Col xl='6' className='box-col-6'>
        <Card className='widget-joins widget-arrow'>
          <CardHeader className='pb-0'>
            <H5>{SaleDetails}</H5>
          </CardHeader>
          <CardBody>
            <Row className='gy-4'>
              {SalesData.map((item) => {
                return (
                  <Col sm='6' key={item.id}>
                    <div className='widget-card'>
                      <Media className='d-flex align-self-center justify-content-between'>
                        <div className={`${item.class1} flex-0-0-auto`}>{item.gros >= 50 ? <i className={`${item.class2} icofont icofont-arrow-up`} /> : <i className={`${item.class2} icofont icofont-arrow-down`} />}</div>
                        <Media body className='text-end'>
                          <H6>{item.week}</H6>
                          <H5>
                            $<CountUp end={item.total} className='counter' />
                            <span className={`ms-1 ${item.class2}`}>
                              {`${item.gros >= 50 ? '+' : '-'}${item.gros}`}%(${item.profit})
                            </span>
                          </H5>
                        </Media>
                      </Media>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};
export default Sales;
